import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.5 14c.6 0 1-.4 1-1s-.4-1-1-1H13V8h8c.5 0 .9-.3 1-.8.1-.5-.1-.9-.6-1.1l-9-4c-.3-.1-.5-.1-.8 0l-9 4c-.4.2-.7.6-.6 1.1.1.5.5.8 1 .8h8v4H7.5c-.6 0-1 .4-1 1s.4 1 1 1H11v7c0 .6.4 1 1 1s1-.4 1-1v-7h3.5zM12 4.1L16.3 6H7.7L12 4.1zM8 16H4v-3c0-.6-.4-1-1-1s-1 .4-1 1v8c0 .6.4 1 1 1s1-.4 1-1v-3h3v3c0 .6.4 1 1 1s1-.4 1-1v-4c0-.6-.4-1-1-1zm12-3c0-.6.4-1 1-1s1 .4 1 1v8c0 .6-.4 1-1 1s-1-.4-1-1v-3h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.6.4-1 1-1h4v-3z"
  />,
  'Terrace'
)
